import styles from '@/features/ap_payees/components/PayeeDetailModal/payeeDetailModal.module.scss';
import { ListViewBody } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';

const cx = classnames.bind(styles);

export type Props = {
  contactPersonName: string | undefined;
};

export const ContactPersonName: FC<Props> = memo(({ contactPersonName }) => {
  return (
    <ListViewBody key='right' className={cx(styles['optional-field'])}>
      <div>{contactPersonName}</div>
    </ListViewBody>
  );
});
ContactPersonName.displayName = 'ContactPersonName';
